import { render, staticRenderFns } from "./documentsShow.vue?vue&type=template&id=b8e76642&"
import script from "./documentsShow.vue?vue&type=script&lang=js&"
export * from "./documentsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports